import { useQuery } from 'react-query';
import { TranscriptService } from '../../../services/v1/interview_intelligence/TranscriptService';

export const useTranscript = (interviewId: number, expand?: string[]) =>
  useQuery({
    queryKey: ['transcript', interviewId, { expand: expand }],
    queryFn: () => TranscriptService.show(interviewId, expand),
  });
